<ion-header class="ion-no-border">

	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button (click)="close()">
				<fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
		<ion-title>Add person</ion-title>
		<ion-buttons *ngIf="online && !loading" slot="end">
			<ion-button (click)="add()">
				<fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>

</ion-header>

<ion-content>

	<ion-grid *ngIf="online && !loading" class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-input #first_name_input type="text" inputmode="text" maxlength="50" label="First name" labelPlacement="stacked" fill="outline" [(ngModel)]="params['first_name']"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="text" inputmode="text" maxlength="50" label="Last name" labelPlacement="stacked" fill="outline" [(ngModel)]="params['last_name']"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="text" inputmode="text" maxlength="100" label="Job title" labelPlacement="stacked" fill="outline" [(ngModel)]="params['job_title']"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input *ngIf="organisation" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentOrganisationPickerModal()" value={{organisation.title}}>
                                <div slot="label">Organisation<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                            <ion-input *ngIf="!organisation" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentOrganisationPickerModal()">
                                <div slot="label">Organisation<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <h3>Contact information</h3>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="email" inputmode="email" maxlength="320" labelPlacement="stacked" fill="outline" [(ngModel)]="params['email_address']">
                                <div slot="label">Email address<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="tel" inputmode="tel" maxlength="20" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mobile_phone_number']">
                                <div slot="label">Mobile phone number<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="tel" inputmode="tel" maxlength="20" labelPlacement="stacked" fill="outline" [(ngModel)]="params['home_phone_number']">
                                <div slot="label">Home phone number<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="tel" inputmode="tel" maxlength="20" labelPlacement="stacked" fill="outline" [(ngModel)]="params['work_phone_number']">
                                <div slot="label">Work phone number<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <h3>Notes</h3>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-textarea type="text" inputmode="text" maxlength="500" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['internal_note']">
                                <div slot="label">Internal note<ion-text class="optional">optional</ion-text></div>
                            </ion-textarea>
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <h3>Mailing address</h3>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input *ngIf="mailing_address_country" class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentMailingAddressCountryPickerModal()" value={{mailing_address_country.title}}></ion-input>
                            <ion-input *ngIf="!mailing_address_country" class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentMailingAddressCountryPickerModal()"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ng-container *ngIf="mailing_address_country">
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="100" label="Line 1" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_line_1']"></ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_line_2']">
                                    <div slot="label">Line 2<ion-text class="optional">optional</ion-text></div>
                                </ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="50" label="Town / city" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_locality']"></ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_subdivision']">
                                    <div slot="label">State / province / region / county<ion-text class="optional">optional</ion-text></div>
                                </ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="10" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_postal_code']">
                                    <div slot="label">ZIP / postcode<ion-text class="optional">optional</ion-text></div>
                                </ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-item lines="none" class="ion-no-padding">
                                    <ion-toggle class="form-toogle" alignment="start" label-placement="stacked" [(ngModel)]="billing_address_same_as_mailing_address" (ionChange)="prefillBillingAddress()">Billing address is the same as mailing address</ion-toggle>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                    </ng-container>
                </ion-grid>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <h3>Billing address</h3>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input *ngIf="billing_address_country" class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentBillingAddressCountryPickerModal()" value={{billing_address_country.title}}></ion-input>
                            <ion-input *ngIf="!billing_address_country" class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentBillingAddressCountryPickerModal()"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ng-container *ngIf="billing_address_country">
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="100" label="Line 1" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_line_1']"></ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_line_2']">
                                    <div slot="label">Line 2<ion-text class="optional">optional</ion-text></div>
                                </ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="50" label="Town / city" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_locality']"></ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_subdivision']">
                                    <div slot="label">State / province / region / county<ion-text class="optional">optional</ion-text></div>
                                </ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="10" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_postal_code']">
                                    <div slot="label">ZIP / postcode<ion-text class="optional">optional</ion-text></div>
                                </ion-input>
                            </ion-col>
                        </ion-row>
                    </ng-container>
                </ion-grid>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <h3>Other</h3>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-item lines="none" class="ion-no-padding">
                                <ion-toggle class="form-toogle" alignment="start" label-placement="stacked" [(ngModel)]="params['create_username']">Create username and send choose password email</ion-toggle>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ng-container *ngIf="pricing_tiers && pricing_tiers.length != 0">
                                <ion-select okText="OK" interface="alert" label="Pricing tier" labelPlacement="stacked" fill="outline" [(ngModel)]="params['pricing_tier_id']">
                                    <ng-container *ngFor="let pricing_tier of pricing_tiers">
                                        <ion-select-option *ngIf="pricing_tier.sellable == true" value="{{pricing_tier.id}}">{{pricing_tier.title}}</ion-select-option>
                                    </ng-container>
                                </ion-select>
                            </ng-container>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-item lines="none" class="ion-no-padding">
                                <ion-toggle class="form-toogle" alignment="start" label-placement="stacked" [(ngModel)]="params['allow_on_account_payment_method']">Allow on account payment</ion-toggle>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ng-container *ngIf="email_lists && email_lists.length != 0">
                                <ion-select multiple okText="OK" interface="alert" [interfaceOptions]="selectOptions" label="Email lists" labelPlacement="stacked" fill="outline" [(ngModel)]="params['email_list_ids']">
                                    <ion-select-option *ngFor="let email_list of email_lists" value="{{email_list.id}}">{{email_list.title}}</ion-select-option>
                                </ion-select>
                            </ng-container>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
	</ion-grid>

</ion-content>